/**
 * Watch sub-tabs, mirroring Flutter's `watch_feed_filter.dart`
 * (All · Trips · Waypoints · Photos · Posts).
 *
 * The wire names differ from the labels: the backend says `waypoint`
 * (singular), and Photos / Posts are waypoint posts narrowed by `sub_type`
 * (a Photo is a waypoint whose type is `moment`, a Post one whose type is `post`).
 */
export type WatchFeedFilterKey = 'trips' | 'waypoints' | 'photos' | 'posts';

export interface WatchFeedFilterTab {
  key: WatchFeedFilterKey;
  label: string;
  /** `type` query param of `GET /watch/`. */
  type: string;
  /** `sub_type` query param, when the tab needs narrowing past `type`. */
  subType?: string;
}

export const WATCH_FEED_FILTER_TABS: readonly WatchFeedFilterTab[] = [
  { key: 'trips', label: 'Trips', type: 'trips' },
  { key: 'waypoints', label: 'Waypoints', type: 'waypoint' },
  { key: 'photos', label: 'Photos', type: 'waypoint', subType: 'moment' },
  { key: 'posts', label: 'Posts', type: 'waypoint', subType: 'post' },
];

const PHOTO_TYPES = ['moment', 'photo', 'photos'];

/**
 * Whether [post] belongs on the Waypoints tab. The server cannot exclude
 * sub-types, and Photos / Posts also arrive as `post_type: 'waypoint'`, so
 * without this the Waypoints tab would repeat them (Flutter does the same).
 */
export function isPlainWaypointPost(post: any): boolean {
  const waypointType = String(post?.waypoint_details?.type ?? '').trim().toLowerCase();
  return !PHOTO_TYPES.includes(waypointType) && waypointType !== 'post';
}

export function watchFilterQuery(key: WatchFeedFilterKey | null): { type?: string; sub_type?: string } {
  const tab = WATCH_FEED_FILTER_TABS.find((t) => t.key === key);
  if (!tab) return {};
  return tab.subType ? { type: tab.type, sub_type: tab.subType } : { type: tab.type };
}
